// tutorial: traduzioni delle stringhe della funzione di traduzione $t
// traduzione dei messaggi d'errore di vee-validate
const pl = {
    'countryCode': 'pl_pl',
    'Accetto il regolamento fidelity e la privacy policy': 'Akceptuję regulamin i politykę prywatności',
    'Account creation': 'Utwórz konto',
    'Add address': 'Dodaj adres',
    'Address': 'Adres',
    'Address label': 'Imię adres',
    'Address label placeholder': 'na przykład: dom, praca...',
    'Amount': 'Kwota',
    'Apply': 'Zastosuj',
    'Apply Discount': 'Zastosuj rabat',
    'Are you sure you want to delete this item from cart': 'Czy jesteś pewny, że chcesz usunąć ten artykuł z koszyka?',
    'Are you sure you want to move this item to wishlist?': 'Czy na pewno chcesz przenieść ten przedmiot na listę życzeń?',
    'articles': 'artykuły',
    'articles inside': 'artykuły w koszyku',
    'Back': 'Powrót',
    'Back to cart': 'Powrót do koszyka',
    'Back to shopping': 'Kontynuuj zakupy',
    'Back to store': 'Powrót do sklepu',
    'Billing address': 'Adres do faktury',
    'Billing address is the same as the shipping address': 'Dane do faktury i dane dostawy pokrywają się',
    'Buy': 'Dokonaj zakupu',
    'Buy Now': 'Kup teraz',
    'Buy now, pay later': 'Kup teraz, zapłać później',
    'Cancel': 'Usuń',
    'Cannot apply Gift Card': 'Nie można zastosować karty podarunkowej',
    'Cannot apply glam card points': 'Nie udało się zastosować punktów z Twojej karty WE Card',
    'Card issuer authentication failed': 'Uwierzytelnienie wystawcy karty nie powiodło się',
    'Cart': 'Koszyk',
    'Cart content': 'Zawartość koszyka',
    'Change': 'reszta',
    'Change address': 'Zmień adres',
    'Change e-mail': 'Zmień adres mail',
    'Change pickup point': 'Zmień punkt odbioru',
    'Check zip code': 'Sprawdź kod pocztowy',
    'Choose a shipping method in order to proceed': 'Aby kontynuować, proszę wybrać sposób wysyłki',
    'Choose a store for the pick-up in order to proceed': 'Wybierz sklep, w którym odbierzesz zamówienie, aby kontynuować',
    'Choose a zipcode in order to proceed': 'Wybierz kod pocztowy, aby kontynuować',
    'City': 'Miasto',
    'Close': 'Zamknij',
    'Closed': 'Zamknięte',
    'Color': 'Kolor',
    'Complete your order': 'Zakończ zamówienie',
    'Condizioni di vendita': 'Warunki sprzedaży',
    'Confirm': 'Potwierdź',
    'Continue': 'Dalej',
    'Continue as guest': 'Kontynuuj jako Gość',
    'Country': 'Państwo',
    'Coupon': 'Kupon',
    'Coupon Code': 'Kod rabatowy',
    'Credit Card': 'Karta kredytowa',
    'Credit Card Number': 'Numer karty',
    'data': 'dane',
    'Date of birth': 'Data urodzenia',
    'Date of Birth': 'Data urodzenia',
    'dd/mm/yyyy': 'dd/mm/rrrr',
    'Delete': 'Usuń',
    'Delivery:': 'Dostawa:',
    'Description': 'Opis',
    'Do you have a discount code?': 'Posiadasz kod rabatowy?',
    'Enter your Gift Card here': 'Wpisz tutaj swoją kartę podarunkową',
    'do-login': 'Zaloguj się',
    'done': 'gotowy',
    'E-mail address': 'Email',
    'Edit': 'Wprowadź zmiany',
    'Edit address': 'Edytuj adres',
    'Edit Cart': 'Wprowadź zmiany do koszyka',
    'Email': 'E-mail',
    'Email and telephone number': 'E-mail i numer telefonu',
    'email-remainder': 'Wysłaliśmy mail do resetowania hasła. Otwórz link, który znajdziesz w mailu.',
    'Empty credit card fields': 'Prosimy o wprowadzenie danych karty kredytowej',
    'Enter shipping address': 'Wpisz adres wysyłki',
    'Enter the points to be used here': 'Enter the points to be used here',
    'Error during payment authorization': 'Błąd autoryzacji płatności',
    'Error during registration': 'Wystąpił błąd podczas rejestracji',
    'Error occurred while placing orde': 'Wystąpił błąd podczas składania zamówienia',
    'Expire Date': 'Data ważności',
    'Female': 'Kobieta',
    'Firstname': 'Imię',
    'Forgot your password?': 'Zapomniałeś hasła?',
    'Free': 'Gratis',
    'Friday': 'piątek',
    'From': 'Z',
    'Gender': 'Płeć',
    'Gift Card': 'Karta podarunkowa',
    'Gift card and discount codes': 'Karta podarunkowa i kody rabatowe',
    'giftcardmsg': 'Giftcard {code}',
    'Glam card discount': 'Zniżka dzięki Punktom WE Card',
    'glamcard-bonusapplied': 'Zastosowano {bonus} punkty z Twojej WE Card',
    'Go to checkout': 'Przejdź do zamówienia',
    'Go to payment': 'Przejdź do płatności',
    'Go to shipping': 'Przejdź do wysyłki',
    'Go to summary': 'Przejdź do podsumowania',
    'Home delivery cost': 'Koszty dostawy do domu',
    'How many points do you want to use?': 'Ile punktów bonusowych chcesz wykorzystać?',
    'How much bonus do you want to use?': 'Ile punktów chcesz wykorzystać?',
    'I don\'t want to receive the invoice': 'Nie potrzebuję faktury',
    'I tuoi contatti telefonici possono servirci per contattarti in caso di domande. Il tuo contatto cellulare ci dà la possibilità di inviarti un SMS gratuito per avvisarti della consegna della merce.': 'Twoje dane kontaktowe pozwolą nam skontaktować się z Tobą w razie pytań. Podanie numeru telefonu komórkowego daje nam możliwość wysłania Ci bezpłatnego SMS-a informującego o dostarczeniu towaru.',
    'I want to receive the invoice': 'Chcę otrzymać fakturę',
    'Identical to shipping address': 'Adres identyczny z adresem dostawy',
    'Insert here coupon code': 'Wprowadź kod rabatowy',
    'Insert here the shipping data': 'Wprowadź tutaj dane dostawy',
    'Insert here your email to proceed, we will send you just the order updates': 'Wprowadź adres mailowy, aby kontynuować. Wyślemy Ci wyłącznie informacje związane z tym zamówieniem',
    'Insert your billing address': 'Wprowadź adres do faktury',
    'invoice': 'płatność',
    'Invoice address': 'Adres do faktury',
    'Last name': 'Nazwisko',
    'Lastname': 'Nazwisko',
    'Leave': 'Wyjdź',
    'Loading': 'Ładowanie',
    'Loading payment form, please wait': 'Trwa ładowanie formularza płatności, proszę czekać',
    'login': 'Login',
    'Login': 'Logowanie',
    'Male': 'Mężczyzna',
    'Message': 'Treść wiadomości',
    'Mobile phone': 'Numer telefonu',
    'Monday': 'poniedziałek',
    'Move item': 'Przenieś artykuł',
    'Move product': 'Przenieś produkt',
    'Name': 'Imię',
    'New address': 'Nowy adres',
    'New client': 'Nowy klient',
    'No items in cart': 'Koszyk jest pusty',
    'No near stores': 'Brak w pobliżu sklepów',
    'No shipping methods available': 'Metody dostawy są niedostępne',
    'Not registered yet?': 'Nie jesteś zarejestrowany?',
    'Ok': 'Ok',
    'Or': 'Albo',
    'Order detail': 'Szczegóły zamówienia',
    'Order details': 'Szczegóły zamówienia',
    'Order placed': 'Złożono zamówienie. Zostaniesz przekierowany na stronę podsumowania',
    'Order will be shipped to': 'Zamówienie zostanie wysłane do',
    'Our online shop handles payments in Euros.<br> You will then be charged the amount of:': 'Nasz sklep internetowy akceptuje wyłącznie płatności w EUR. W wyniku zmian kursu walut, kwota zablokowana podczas składania zamówienia może się nieznacznie różnić od rzeczywistej opłaty, naliczonej w momencie potwierdzenia zamówienia.<br> Za twoje zamówienie zostanie pobrana następująca opłata:',
    'Password': 'Hasło',
    'Password confirm': 'Potwierdź hasło',
    'Pay': 'Zapłać',
    'payment': 'Płatność',
    'Payment': 'Płatność',
    'Payment error.': 'Błąd płatności.',
    'Payment method': 'Sposób płatności',
    'Payment method not supported': 'Metoda płatności została odrzucona',
    'Personal data': 'Dane osobowe',
    'Place of birth': 'Miejsce urodzenia',
    'Place of Birth': 'Miejsce urodzenia',
    'Please select shipping from Amazon widget': 'Wybierz sposób dostawy z widgetu Amazon',
    'Please try again with another form of payment': 'Spróbuj jeszcze raz korzystając z innej formy płatności',
    'Please wait': 'Proszę czekać',
    'Please wait, payment is processing': 'Proszę czekać, trwa przetwarzanie płatności',
    'Prefix': 'Prefiks',
    'Postcode': 'Kod pocztowy',
    'Proceed': 'Dalej',
    'Proceed delete': 'Kontynuuj',
    'Proceed to payment': 'Przejdź do płatności',
    'Proceed with the purchase': 'Przejdź do zakupu',
    'product': 'produkt',
    'Product': 'Produkt',
    'products': 'produkty',
    'Products total': 'Wszystkie produkty',
    'Quantity': 'Ilość',
    'Register': 'Zarejestruj się',
    'Registered User': 'zarejestrowany użytkownik',
    'Registration agreement': 'Regulamin rejestracji',
    'Registration successful': 'Pomyślnie zarejestrowano',
    'registrationagreement': 'Akceptuję <a href="{linkfid}" target="_blank">regulamin</a> i <a href="{linkpriv}" target="_blank">politykę prywatności</a>',
    'Remove': 'Usuń',
    'Remove Discount': 'Usuń rabat',
    'Remove the item': 'Usuń artykuł',
    'Required fields': 'Wymagane pola',
    'Retry': 'Spróbuj ponownie',
    'review': 'podsumowanie',
    'Safe purchase': 'Bezpieczny zakup',
    'Same as billing': 'Taki sam jak rozliczeniowy',
    'Saturday': 'sobota',
    'Save': 'Zapisz',
    'Save address': 'Zapisz adres',
    'Save in address book': 'Zapisz w książce adresowej',
    'Save new address to proceed': 'Zapisz nowy adres, aby kontynuować',
    'Select': 'Wybierz',
    'Select a city': 'Wybierz miasto',
    'Select a payment method': 'Wybierz sposób płatności',
    'Select a region': 'Wybierz województwo',
    'Select an address': 'Wybierz adres',
    'Select here your shipping address': 'Wybierz tutaj adres dostawy',
    'Select payment method': 'Wybierz sposób płatności',
    'Select region': 'Wybierz województwo',
    'Select shipping method': 'Wybierz sposób dostawy',
    'Select store pickup': 'Wybierz odbiór w sklepie',
    'Select store pickup to precede': 'Wybierz odbiór w sklepie, aby kontynuować',
    'Select the store': 'Wybierz sklep',
    'Select this store': 'Wybierz ten sklep',
    'Select value': 'Wybierz wartość',
    'Selected Store': 'Wybrany sklep',
    'Seleziona il metodo di spedizione': 'Wybierz sposób dostawy',
    'Send remainder': 'Wyślij mail do resetowania hasła',
    'Service unavailable, retry later': 'Wystąpił tymczasowy błąd, spróbuj ponownie później',
    'Session expired, page will reload': 'Sesja wygasła, strona zostanie ponownie załadowana',
    'shipping': 'Dostawa',
    'Shipping': 'Dostawa',
    'Shipping address': 'Adres dostawy',
    'Shipping and handling': 'Dostawa i obsługa',
    'Shipping data': 'Dane dostawy',
    'Shipping informations': 'Informacje o dostawie',
    'Shop opening hours': 'Godziny otwarcia sklepu',
    'Shopping Cart': 'Koszyk',
    'shopping details': 'szczegóły zakupów',
    'Size': 'Rozmiar',
    'Something went wrong during Yandex Checkout': 'Coś poszło nie tak podczas płatności Yandex',
    'State/Region': 'Powiat',
    'Store selection': 'Wybierz sklep',
    'street': 'ulica',
    'Street': 'Ulica',
    'Street number': 'Numer budynku i numer mieszkania',
    'Sunday': 'niedziela',
    'Surname': 'Nazwisko',
    'Tax included': 'Podatek wliczony w cenę',
    'Telephone': 'Telefon',
    'Telephone number': 'Numer telefonu',
    'Telephone number for courier / store pickup': 'Numer telefonu dla kuriera/odbioru w sklepie',
    'Terranova stores near you': 'Sklepy Terranova w pobliżu',
    'The coupon code isn\'t valid. Verify the code and try again.': 'Kupon jest nieważny. Sprawdź kod i spróbuj ponownie.',
    'The gift card is invalid or empty. Please check the gift card and try again': 'Karta podarunkowa jest nieważna lub nie zawiera żadnych środków. Sprawdź kartę podarunkową i spróbuj ponownie.',
    'The maximum value of the usable We+Card bonus is': 'Maksymalna wartość zniżki z WE Card wynosi',
    'The maximum value of the usable WE+Card points is': 'Maksymalna wartość punktów WE Card do wykorzystania wynosi',
    'The order is already been paid, please wait while order is placing': 'Zamówienie zostało już opłacone, poczekaj na złożenie zamówienia',
    'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).': 'Hasło musi składać się z minimum 8 znaków i zawierać małą literę, dużą literę, cyfrę oraz znak specjalny (.;,!$#).',
    'The requested qty is not available': 'Wybrana ilość jest niedostępna',
    'There has been an error. Please try again': 'Wystąpił błąd. Spróbuj ponownie',
    'This email already esists. Do the login or proceed as guest': 'Ten adres już istnieje. Zaloguj się albo kontynuuj jako gość',
    'This product is not available, please remove it from cart to proceed': 'Ten produkt jest niedostępny. Usuń go z koszyka, aby kontynuować',
    'Thursday': 'czwartek',
    'To': 'Do',
    'Total': 'Razem',
    'Tuesday': 'wtorek',
    'Type of card': 'Rodzaj karty',
    'Update address': 'Zaktualizuj adres',
    'Use Glam Card Bonus': 'Wykorzystaj punkty bonusowe z karty WE Card',
    'Use points': 'Użyj punktów bonusowych',
    'Use WE+ points': 'Wykorzystaj swoje punkty WE Card',
    'User': 'Użytkownik',
    'Valid until': 'ważne do',
    'VAT number': 'NIP',
    'Verify billing address': 'Potwierdź adres faktury',
    'Verify Gift Card': 'Zweryfikuj kartę podarunkową',
    'Verify payment method selection': 'Potwierdź wybór sposobu płatności',
    'Verify shipping address': 'Potwierdź adres dostawy',
    'Verify shipping method selection': 'Potwierdź wybór metody wysyłki',
    'View your cart': 'Zobacz swój koszyk',
    'Wait for page to reload': 'Poczekaj na ponowne załadowanie strony',
    'We\'re unable to send the password reset email': 'Nie udało się wysłać maila do resetowania hasła. Sprawdź, czy podałeś prawidłowy adres mailowy',
    'Wednesday': 'środa',
    'You are ordering with this email address': 'Zamawiasz z tym adresem mailowym',
    'You are shipping in a foreign country': 'Dostawa za granicę',
    'Your available points': 'Twoje dostępne punkty',
    'Your avalaible bonus': 'Saldo punktów bonusowych',
    'Zip code': 'Kod pocztowy',
    'Zip or city': 'Kod pocztowy lub miejscowość',
    'weplus-pointstonext': 'Brakuje Ci {expense} do osiągnięcia kolejnego poziomu',
    'zipdigitwarnings': 'Warning the zip code should consist of {zipdigits} charachters',
    'Shipping cost excluded': 'Bez kosztów wysyłki',
    'Extra address': 'Informacje dodatkowe (opcjonalne)',
    'Extra address placeholder': 'osoba/firma, numer wewnętrzny, osiedle/sołectwo, nazwa na domofonie',
    '8 characters': '8 znaków',
    '1 lowercase letter': '1 mała litera',
    '1 uppercase letter': '1 duża litera',
    '1 number': '1 cyfra',
    '1 special character': '1 znak specjalny',
    'Now you can use your points': 'Teraz możesz wykorzystać swoje punkty',
    'Hallo': 'Cześć',
    'Save Credit Card (One Click Payment)': 'Zapisz kartę kredytową (płatność jednym kliknięciem)',
    'Pay with a saved credit card': 'Zapłać zapisaną kartą kredytową',
    'Pay with a new credit or debit card': 'Zapłać nową kartą kredytową lub debetową',
    'Expiration': 'Data ważności',
    'Other': 'Inne',
    'Applied discounts': 'Zastosowane rabaty',
    'Choose size': 'Wybierz rozmiar',
    'Municipality': 'Gmina',
    'amount-for-freeshipping': 'Brakuje Ci {amount} do darmowej wysyłki kurierem',
    'klarna-threshold-warning': 'Płatność za pomocą Klarna jest możliwa tylko za minimalną kwotę {amount} euro',
    'To proceed you must select a payment method': 'W celu kontynuowania należy wybrać metodę płatności',
    'To proceed you need to save the selected billing address': 'W celu kontynuowania należy zapisać wybrany adres rozliczeniowy',
    'To proceed it is necessary to accept the general conditions of sale': 'W celu kontynuowania należy zaakceptować ogólne warunki sprzedaży',
    'To proceed you need to select the store': 'W celu kontynuowania należy wybrać sklep',
    'To proceed you need to save your changes': 'W celu kontynuowania należy zapisać zmiany',
    'Are you sure you want to delete this address?': 'Czy na pewno chcesz usunąć ten adres?',
    'To proceed you need to save the selected shipping address': 'Aby kontynuować musisz zapisać wybrany adres wysyłki',
    'message-double_optin_using_point_disabled': 'Nie możesz wymienić punktów za ten zakup, ponieważ nie potwierdziłeś jeszcze ważności swojego adresu e-mail lub numeru telefonu. W razie jakichkolwiek pytań prosimy o kontakt z naszym działem obsługi klienta.',
}

export default pl;
export const plValidation = {
    name: "pl",
    messages: {
        _default: function (e: any) {
            return "Wartość pola " + e + " jest nieprawidłowa."
        },
        after: function (e: any, n: any) {
            return "" + e + " musi być po " + n[0] + "."
        },
        alpha: function (e: any) {
            return "Pole " + e + " może zawierać wyłącznie litery."
        },
        alpha_dash: function (e: any) {
            return "Pole " + e + " może zawierać znaki alfanumeryczne, jak również pauzy i znaki podkreślenia."
        },
        alpha_num: function (e: any) {
            return "Pole " + e + " może zawierać wyłącznie znaki alfanumeryczne."
        },
        alpha_spaces: function (e: any) {
            return "Pole " + e + " może zawierać wyłącznie znaki alfanumeryczne i spacje."
        },
        before: function (e: any, n: any) {
            return "Pole " + e + " musi być przed " + n[0] + "."
        },
        between: function (e: any, n: any) {
            return "Pole " + e + " musi być pomiędzy " + n[0] + " a " + n[1] + "."
        },
        confirmed: function (e: any, n: any) {
            return "Pole " + e + " nie odpowiada " + n[0] + "."
        },
        credit_card: function (e: any) {
            return "Pole " + e + " jest nieprawidłowe."
        },
        date_between: function (e: any, n: any) {
            return "Tam " + e + " musi być zawarta między " + n[0] + " a " + n[1] + "."
        },
        date_format: function (e: any, n: any) {
            return "Tam " + e + " musi być w formacie " + n[0] + "."
        },
        decimal: function (e: any, n: any) {
            void 0 === n && (n = []);
            var r = n[0];
            return void 0 === r && (r = "*"), "Pole " + e + " musi być numeryczne i może zawierać" + (r && "*" !== r ? " " + r : "") + " miejsc/-a po przecinku."
        },
        digits: function (e: any, n: any) {
            return "Pole " + e + " musi być numeryczne i musi zawierać dokładnie " + n[0] + " cyfr."
        },
        dimensions: function (e: any, n: any) {
            return "Pole " + e + " musi być " + n[0] + " x " + n[1] + "."
        },
        email: function (e: any) {
            return "Pole " + e + " musi być prawidłowym adresem mailowym."
        },
        excluded: function (e: any) {
            return "Pole " + e + " musi zawierać prawidłową wartość."
        },
        ext: function (e: any) {
            return "Pole " + e + " musi być prawidłowym plikiem."
        },
        image: function (e: any) {
            return "Pole " + e + " musi być obrazem."
        },
        included: function (e: any) {
            return "Pole " + e + " musi zawierać prawidłową wartość."
        },
        ip: function (e: any) {
            return "Pole " + e + " musi być prawidłowym adresem IP."
        },
        length: function (e: any, n: any) {
            return "Długość pola " + e + " musi być " + n[0] + "."
        },
        max: function (e: any, n: any) {
            return "Pole " + e + " nie może zawierać więcej niż " + n[0] + " znaków."
        },
        max_value: function (e: any, n: any) {
            return "Pole " + e + " musi być równe lub mniejsze niż " + n[0]
        },
        mimes: function (e: any) {
            return "Pole " + e + " musi zawierać prawidłowy plik."
        },
        min: function (e: any, n: any) {
            return "Pole " + e + " musi zawierać co najmniej " + n[0] + " znaków."
        },
        min_value: function (e: any, n: any) {
            return "Pole " + e + " musi być równe lub większe niż " + n[0]
        },
        numeric: function (e: any) {
            return "Pole " + e + " może zawierać wyłącznie liczby."
        },
        regex: function (e: any) {
            return "Pole " + e + " ma nieprawidłowy format."
        },
        required: function (e: any) {
            return "Pole " + e + " jest wymagane."
        },
        size: function (e: any, n: any) {
            return "Pole " + e + " musi być mniejsze niż " + function (e) {
                const n = 1024;
                const r = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / Math.pow(n, r)).toFixed(2));
                const v = 1 * f;
                return v.toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r]
            }(n[0]) + "."
        },
        url: function (e: any) {
            return "Pole " + e + " nie jest prawidłowym URL."
        },
        'validate-piva-cf': function (e: any) {
            return 'Nieprawidłowy numer VAT/kod podatkowy.';
        },
        'validate-regionid': function (e: any) {
            return 'Pole Prowincja jest wymagane.';
        },
        'validate-ascii': function(e: any) {
            return 'Wpisz swoje imię i nazwisko bez polskich znaków';
        },
        'validate-streetandnumber': function(e: any, n: any) {
            return 'Street and street number fields must not exceed {2} charachters';
        },
        'validate-data-consensus': function(e: any) {
          return 'Twoja zgoda jest wymagana do przetwarzania danych osobowych.';
        },
        'validate-gender': function(e: any) {
            return 'Pole Płeć jest wymagane.';
        },
        'validate-password': function(e: any) {
            return 'Hasło musi składać się z minimum 8 znaków i zawierać małą literę, dużą literę, cyfrę oraz znak specjalny (.;,!$#).';
        },
    },
    attributes: {}
};
